/**
 * Converts a formatted price string into a numeric value for clickstream payloads.
 *
 * @param {string} price - Formatted price text, such as "$12.34".
 * @returns {number} Parsed numeric price value.
 */
export function convertPriceStringToFloat(price) {
    const cleanPriceString = String(price || "").replace(/[^\d.-]/g, "");
    return parseFloat(cleanPriceString);
}